// Object to query string
export const objectToQueryString = (queryParameters) =>
  queryParameters
    ? Object.entries(queryParameters).reduce((q, [k, v]) => {
        const symbol = q.length === 0 ? '?' : '&'
        return q + (['string', 'number', 'boolean'].includes(typeof v) ? `${symbol}${k}=${encodeURIComponent(v)}` : '')
      }, '')
    : ''

// Query string to object
export const queryStringToObject = (url) =>
  [...new URLSearchParams(url.split('?')[1])].reduce((a, [k, v]) => ((a[k] = v), a), {})
